import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { NgForm, NgModel } from '@angular/forms';

import { TranslateService } from '@ngx-translate/core';

import { Constantes } from '../../../shared/constantes';

import { SolicitudService } from '../../services/solicitud.service';

import { AutenticacionService } from '../../../shared/services/autenticacion.service';

import { Solicitud } from '../../../shared/models/solicitud';
import { TipoIdentificacion } from '../../../shared/models/tipo-identificacion';
import { Departamento } from '../../../shared/models/departamento';
import { Municipio } from '../../../shared/models/municipio';
import { Mensaje } from '../../../shared/models/mensaje';
import { RespuestaSolicitud } from '../../../shared/models/respuesta-solicitud';

import { AlertaService } from '../../../shared/components/alerta/alerta.service';
import { SpinnerService } from '../../../shared/components/spinner/spinner.service';

declare var $: any;

@Component({
  selector: 'app-solicitud',
  templateUrl: './solicitud.component.html',
  styleUrls: ['./solicitud.component.css']
})
export class SolicitudComponent implements OnInit {
  @ViewChild('f') form: NgForm;
  @ViewChild('captcha') captcha: NgModel;
  @ViewChild('modal') modal: ElementRef;
  @ViewChild('modalText') modalText: ElementRef;

  reCaptchaSiteKey: string = '';
  tiposIdentificacionSolicitud: TipoIdentificacion[] = [];
  tiposIdentificacionSolicitante: TipoIdentificacion[] = [];
  departamentos: Departamento[] = [];
  municipios: Municipio[] = [];
  opcionesMismoSolicitante = ['SI', 'NO'];
  mismoSolicitante = 'SI';
  nombreConductor: string;
  departamentoSeleccionado: string = null;
  correoElectronicoSolicitante: string;
  aceptarTerminos: boolean;
  aceptarPoliticas: boolean;
  formEnviado: boolean;
  solicitud: Solicitud;
  habilitarSolicitud: boolean;

  constructor(private translate: TranslateService,
    private autenticacionService: AutenticacionService,
    private solicitudService: SolicitudService,
    private alertaService: AlertaService,
    private spinnerService: SpinnerService,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.autenticacionService.logout();

    this.activatedRoute.data
      .subscribe(
      (data: Data) => {
        this.reCaptchaSiteKey = data['siteKey'];
      }
      );

    this.cargarTiposIdentificacionSolicitud();
    this.cargarTiposIdentificacionSolicitante();
    this.cargarDepartamentos();

    this.limpiarSolicitud();
  }

  cargarTiposIdentificacionSolicitud() {
    this.solicitudService.getTiposIdentificacionSolicitud()
      .subscribe(
      (data) => {
        this.tiposIdentificacionSolicitud = data
      },
      (error) => { this.alertaService.error('Error al consultar los tipos de identificación para el conductor, por favor intente mas tarde.') }
      );
  }

  cargarTiposIdentificacionSolicitante() {
    this.solicitudService.getTiposIdentificacionSolicitante()
      .subscribe(
      (data) => { this.tiposIdentificacionSolicitante = data },
      (error) => { this.alertaService.error('Error al consultar los tipos de identificación para el solicitante, por favor intente mas tarde.') }
      );
  }

  cargarDepartamentos() {
    this.solicitudService.getDepartamentos()
      .subscribe(
      (data) => { this.departamentos = data },
      (error) => { this.alertaService.error('Error al consultar los departamentos, por favor intente mas tarde.') }
      );
  }

  cargarMunicipios() {
    this.municipios = [];
    this.solicitud.codigoMunicipioSolicitante = null;

    if (this.departamentoSeleccionado != null && this.departamentoSeleccionado != 'null') {
      this.solicitudService.getMunicipios(this.departamentoSeleccionado)
        .subscribe(
        (data) => { this.municipios = data },
        (error) => { this.alertaService.error('Error al consultar los municipios, por favor intente mas tarde.') }
        );
    } else {
      this.departamentoSeleccionado = null;
    }
  }

  cargarNombreConductor(esTipoIdentificacion: boolean) {
    this.nombreConductor = '';
    this.habilitarSolicitud = false;

    this.alertaService.clear();

    if (!esTipoIdentificacion) {
      if (this.solicitud.tipoIdentificacion && this.solicitud.numeroIdentificacion) {
        this.spinnerService.show();

        this.solicitudService.validarConductor(this.solicitud)
          .subscribe(
          (data) => {
            if (data.codigoRespuesta == Constantes.CODIGO_RESPUESTA_OK) {
              this.habilitarSolicitud = true;

              this.nombreConductor = data.object;
            } else {
              var respuestaSolicitud: RespuestaSolicitud = data.object;

              if (data.mensaje) {
                this.alertaService.warning(data.mensaje);
              }

              if (respuestaSolicitud != null) {
                if (respuestaSolicitud.mensajeUrlActualizacionInformacion) {
                  this.alertaService.warning_noclose(respuestaSolicitud.mensajeUrlActualizacionInformacion);
                }
              }

              this.limpiarSolicitud();
            }

            this.spinnerService.hide();
          },
          (error) => { this.alertaService.error('Error al valdiar la información del conductor, por favor intente mas tarde.') }
          );
      }
    } else {
      this.solicitud.numeroIdentificacion = '';
      this.nombreConductor = '';
    }
  }

  generarSolicitud() {
    this.formEnviado = true;

    this.alertaService.clear();

    if (this.form.valid) {

      if (this.mismoSolicitante === 'SI'
        || this.solicitud.correoElectronicoSolicitante === this.correoElectronicoSolicitante) {
        this.solicitud.esSolicitud = true;

        if (this.mismoSolicitante === 'SI') {
          this.solicitud.mismoSolicitante = true;
        } else {
          if (this.solicitud.tipoIdentificacion == this.solicitud.tipoIdentificacionSolicitante
            && this.solicitud.numeroIdentificacion == this.solicitud.numeroIdentificacionSolicitante) {
            this.alertaService.warning('La identificación del conductor y del solicitante no puede ser la misma. Por favor verifique la información ingresada.');
            return;
          }
        }

        this.spinnerService.show();

        this.solicitudService.generarSolicitud(this.solicitud)
          .subscribe(
          (data) => {
            if (data.codigoRespuesta == Constantes.CODIGO_RESPUESTA_OK) {

              if (data.mensaje) {
                this.alertaService.success(data.mensaje);
              }

              this.limpiarSolicitud();
            } else {
              var respuestaSolicitud: RespuestaSolicitud = data.object;

              if (data.mensaje) {
                this.alertaService.warning(data.mensaje);

                this.limpiarCaptcha();
              }

              if (respuestaSolicitud != null) {
                //muestra mensaje de confirmacion
                if (respuestaSolicitud.mostrarConfirmacion) {
                  $(this.modal.nativeElement).modal('show');
                  $(this.modalText.nativeElement).html(respuestaSolicitud.mensajeConfirmacion);
                }
                //muestra mensaje con la url de actualizacion de datos
                else if (respuestaSolicitud.mensajeUrlActualizacionInformacion) {
                  this.alertaService.warning_noclose(respuestaSolicitud.mensajeUrlActualizacionInformacion);

                  this.limpiarCaptcha();
                }
              }
            }

            this.spinnerService.hide();
          },
          (error) => { this.alertaService.error('Error al generar la solicitud, por favor intente mas tarde.') }
          );

      } else {
        this.alertaService.warning('Los correos electrónicos ingresados no coinciden, por favor verifique y vuelva a intentar.');

        this.limpiarCaptcha();
      }
    } else {
      this.limpiarCaptcha();
    }
  }

  confirmarSolicitud() {
    $(this.modal.nativeElement).modal('hide');

    this.spinnerService.show();

    this.solicitudService.continuarGeneracionSolicitud(this.solicitud)
      .subscribe(
      (data) => {
        this.limpiarSolicitud();

        if (data.codigoRespuesta == Constantes.CODIGO_RESPUESTA_OK) {

          if (data.mensaje) {
            this.alertaService.success(data.mensaje);
          }
        } else {
          this.alertaService.warning(data.mensaje);
        }
        this.spinnerService.hide();
      },
      (error) => { this.alertaService.error('Error al confirmar la creación de la solicitud, por favor intente mas tarde.') }
      );
  }

  cancelarConfirmacionSolicitud() {
    $(this.modal.nativeElement).modal('hide');
    this.limpiarSolicitud();
  }

  limpiarSolicitud() {
    this.formEnviado = false;
    this.mismoSolicitante = 'SI';
    this.nombreConductor = '';
    this.departamentoSeleccionado = null;
    this.correoElectronicoSolicitante = '';
    this.aceptarTerminos = false;
    this.aceptarPoliticas = false;
    this.solicitud = new Solicitud(false, false, '', '', '', '', '', '', '', null, '');

    this.limpiarCaptcha();
  }

  limpiarCaptcha() {
    this.solicitud.reCaptcha = '';
    this.captcha.reset();
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/public/components/solicitud/solicitud.component.ts